<template lang="pug">
div
  h1 Dummy page
  BriqPanel
    h2 dummy content
</template>

<script>
export default {
  name: 'BriqDummyPage',
}
</script>

<style scoped lang="stylus"></style>
